import request from '@/utils/request'
import qs from 'qs'

// 公告列表
export const getNoticeList = (data: any) =>
  request({
    url: '/notice/announcement/list',
    method: 'get',
    params: data
  })

// 删除公告
export const deleteNotice = (data: { ids: string }) =>
  request({
    url: '/notice/announcement/delete',
    method: 'post',
    data: qs.stringify(data)
  })

// 获取公告详情
export const getNoticeDetail = (data: { id: number }) =>
  request({
    url: '/notice/announcement/edit',
    method: 'get',
    params: data
  })

// 保存或者修改公告 http://192.168.8.189:8081
export const modifyNotice = (data: any) =>
  request({
    url: '/notice/announcement/option',
    method: 'post',
    data: qs.stringify(data)
  })

export const noticeSwitch = (data: any) =>
  request({
    url: '/notice/announcement/switch',
    method: 'post',
    data: qs.stringify(data)
  })
